var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3511 3.35913L1.3468 14.3642C1.29144 14.4197 1.25146 14.4898 1.23242 14.5652L0.0127046 19.4609C-0.0237807 19.6083 0.0195258 19.765 0.127078 19.8725C0.208456 19.9539 0.31934 19.999 0.432762 19.999C0.467502 19.999 0.503035 19.9947 0.537617 19.986L5.43331 18.7661C5.50961 18.747 5.57893 18.7072 5.6343 18.6519L16.6395 7.64758L12.3511 3.35913Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3659 1.8587L18.141 0.633746C17.3223 -0.184952 15.8954 -0.184159 15.0776 0.633746L13.5771 2.13424L17.8654 6.42254L19.3659 4.92204C19.7749 4.51324 20.0002 3.96914 20.0002 3.39045C20.0002 2.81176 19.7749 2.26765 19.3659 1.8587Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.71e7458b0251e059ff5c59ba8b47b0b6.svg";
export { ForwardRef as ReactComponent };